
import { defineComponent, PropType } from 'vue'

import { Option } from '@/core/types/oktell.types'

export default defineComponent({
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array as PropType<Option[]>,
            default: () => [],
        },
        value: {
            type: [Number, Object] as PropType<number | any>,
            default: null,
        },
        label: {
            type: String,
            default: 'name',
        },
        selectBy: {
            type: String,
            default: 'id',
        },
        returnOption: {
            type: Boolean,
            default: false,
        },
        disabledOptionsIds: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const onClick = (option: Option) => {
            if (props.disabled || isRadioDisabled(option)) return

            if (props.returnOption) {
                emit('update:value', { ...option })
                emit('change', { ...option })
            } else {
                emit('update:value', option.id)
                emit('change', option.id)
            }
        }

        const isRadioActive = (option: Option) => {
            if (!props.value) return false

            if (props.returnOption) {
                return props.value[props.selectBy] === option[props.selectBy as 'id' | 'name']
            } else {
                return props.value === option.id
            }
        }

        const isRadioDisabled = (option: Option) => {
            return props.disabledOptionsIds.includes(option.id)
        }

        return {
            onClick,
            isRadioActive,
            isRadioDisabled,
        }
    },
})
